var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-container"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }